import ApiRequester from './ApiRequester';

export default class {
  constructor() {
    this.apiUrls = {
      getProducts: '/products',
      detail: '/products/detail',
      getInternalProducts: '/internal-products'
    };
    this.lastCall = 0;
    this.currentCall = 0;
    this.rw = null;
    return this;
  }

  finishCall() {
    this.lastCall += 1;
  }

  getProducts(payload) {
    this.rw = new ApiRequester();
    this.rw.method = 'get';
    this.currentCall += 1;
    this.rw.url = this.apiUrls.getProducts;
    if(payload.sku){
      this.rw.url = `${this.apiUrls.getProducts}?page=${payload.page}&sku=${payload.sku}`;
    } else {
      this.rw.url = `${this.apiUrls.getProducts}?page=${payload.page}`;
    }


    return this.rw.submitRequest();
  }

  detail(payload) {
    const rw = new ApiRequester();
    rw.method = 'get';
    rw.data = payload;
    rw.url = this.apiUrls.getProducts;
    rw.url = `${this.apiUrls.detail}?marketplace=${payload.marketplace.toLowerCase()}&product_id=${payload.id}`;
    return rw.submitRequest();
  }

  cancelPreviousRequest() {
    if (this.currentCall !== this.lastCall) {
      this.rw.cancelPreviousRequest();
    }
  }
}
